import { AxiosConfigExplore } from "Explore/Config/AxiosConfig";

export const getAllVenueExplore = (page, rowsPerPage, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/venue/explore?page=${page}&rowsPerPage=${rowsPerPage}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getVenueProfileSummaryByID = (id, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/venue/summary?venueId=${id}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getVenueKeywordsByID = (
  id,
  time_filter,
  granularityLevel,
  params,
  callback
) => {
  const axios = AxiosConfigExplore();
  let url = `/venue/keyword_cloud?venueId=${id}&granularityLevel=${
    granularityLevel - 1
  }&time_filter=${time_filter}`;
  if (params) {
    url = url + `&${params}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

// Promise-based variant used by useInfinityPagination (see InstitutionPublications
// pattern). `numPages` lets the hook prefetch several pages per request, like the
// list pages / faculty list. Errors are rethrown so callers can handle 401.
export const getVenueTopPapersByID = async ({
  venueId,
  page,
  rowsPerPage,
  time_filter,
  keywords,
  numPages,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/venue/v2/top_papers?venueId=${venueId}&page=${page}&rowsPerPage=${rowsPerPage}&time_filter=${time_filter}`;
  if (numPages) {
    url += `&numPages=${numPages}`;
  }
  if (keywords?.length > 0) {
    const params = new URLSearchParams();
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("keyword", keyword.value);
      }
    });
    url += `&${params.toString()}`;
  }
  const res = await axios.get(url);
  return res.data;
};

export const getVenueTopAuthorsSuggestion = async ({
  id,
  query,
  time_filter,
  keywords,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/venue/top_authors/suggest?venue_id=${id}&query=${query}&time_filter=${time_filter}`;
  if (keywords?.length > 0) {
    let params = new URLSearchParams();
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("keyword", keyword.value);
      }
    });
    url += `&${params.toString()}`;
  }
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getVenueTopAuthorsByID = (
  id,
  page,
  rowsPerPage,
  query,
  time_filter,
  keywords,
  callback
) => {
  const axios = AxiosConfigExplore();
  let url = `/venue/top_authors?venueId=${id}&page=${page}&rowsPerPage=${rowsPerPage}&time_filter=${time_filter}`;
  if (!!query) {
    url = url + `&queries=${query}`;
  }
  if (keywords.length > 0) {
    let params = new URLSearchParams();
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("keyword", keyword.value);
      }
    });
    url += `&${params.toString()}`;
  }

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getVenueTopInstitutionsByID = (
  id,
  page,
  rowsPerPage,
  keywords,
  time_filter,
  callback
) => {
  const axios = AxiosConfigExplore();
  let url = `/venue/top_institutions?venueId=${id}&page=${page}&rowsPerPage=${rowsPerPage}&time_filter=${time_filter}`;
  if (keywords.length > 0) {
    let params = new URLSearchParams();
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("keyword", keyword.value);
      }
    });
    url += `&${params.toString()}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getSearchVenues = (filters, callback) => {
  const axios = AxiosConfigExplore();
  let url = `/venue/search`;
  let queryBody = filters;
  axios
    .post(url, queryBody)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

// Promise-based variant used by useInfinityPagination (see FacultyList pattern).
// Errors are rethrown so callers can handle 401 (login-required) via errCallback.
export const searchVenues = async (data) => {
  const axios = AxiosConfigExplore();
  const url = `/venue/v2/search`;
  const res = await axios.post(url, data);
  return res.data;
};

export const getSuggestSearchVenues = (params, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/venue/suggest/${params}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
